export default __webpack_public_path__ + "static/media/BrainBreak cards46.b837b312.png";